import { useCallback } from "react";

import type { ReservationCancelInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "../../repository/mutation";

export const useUpdateReservationDetailCancel = (hotelID: string, reservationID: string) => {
	const { onUpdateReservationDetailCancel: _onUpdateReservationDetailCancel } =
		MutationRepository.useReservationDetailCancelUpdateMutation();

	/**
	 * 予約詳細のキャンセルを実行
	 */
	const onUpdateReservationDetailCancel = useCallback(
		async (canceledPrice: ReservationCancelInput["canceledPrice"]) => {
			const input: ReservationCancelInput = {
				hotelID,
				reservationID,
				canceledPrice,
			} satisfies ReservationCancelInput;
			await _onUpdateReservationDetailCancel(input);
		},
		[_onUpdateReservationDetailCancel, hotelID, reservationID],
	);

	return {
		onUpdateReservationDetailCancel,
	};
};
